<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'About',

    metaInfo: { title: 'Qui sommes-nous ?' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'cards',
        // 'expandables',
        // 'statuts',
        'conseil',
        'contact-us',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'about',
      },
    },
  }
</script>
